<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="legal" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>Terms of Use</h1>
      <p>By accessing GB Wave, you agree to follow these Terms of Use. Please read these terms carefully before using our website.</p>

      <h2>Website Content</h2>
      <p>
        GB Wave provides information, guides, and educational content related to GB WhatsApp and Android applications.
      </p>
      <p>
        We aim to keep our information accurate and updated, but application features, versions, and availability may change over time.
      </p>

      <h2>Independent Website</h2>
      <p>
        GB Wave is an independent website and is not affiliated with WhatsApp LLC, Meta Platforms, Inc., or any official WhatsApp products.
      </p>

      <h2>User Responsibility</h2>
      <p>
        Users are responsible for understanding the risks and requirements of any third-party applications before installation or use.
      </p>
      <p>
        GB Wave does not guarantee that third-party applications will work on every device.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We may update these Terms of Use when necessary. Continued use of the website means you accept the updated terms.
      </p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'TermsPage',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Terms of Use', current: true },
      ],
    };
  },
};
</script>
